import { ILookupState } from './lookup-states.store';
import { GetterTree } from 'vuex';
import lookupTypesStore from './lookup-types.store';
import { LOOKUP_TYPE } from './lookup-properties.store';
import { LOOKUP_ADMINISTRATION_FLOODTYPE, LOOKUP_ASBESTOS_TYPE } from '../../common/lookup-types.constant';
import { deepCopy } from '../../utils/util';

const getters: GetterTree<ILookupState, {}> = <GetterTree<ILookupState, {}>>{
  service: (state: ILookupState) => state.service,
    storedlookupObject: (state: ILookupState) => state.storedlookupObject,
  listOfDemandStatus: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.DemandStatus] || [],
  listOfDemandPurposes: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.DemandPurpose] || [],
  listOfCommonGoals: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.ObjectGoal] || [],
  listOfCommonManagers: (state: ILookupState) => {
    let result = deepCopy(state.storedlookupObject[LOOKUP_TYPE.Manager]) || [];
    if (result && result[0] && result[0].Name) {
      return result.sort(function (a, b) {
        if (!a || !b) {
          return 0;
        }

        let nameA = a.Name ? a.Name.toUpperCase() : (a.Id ? a.Id.toString() : '');
        let nameB = b.Name ? b.Name.toUpperCase() : (b.Id ? b.Id.toString() : '');
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      })
    } else {
      return result;
    }
  },

  getlistOfEmailByPropertyIds: (state: ILookupState) => state.listOfEmailByPropertyIds,
  listOfAddressTitles: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.AddressTitle] || [],
  listOfC21Professions: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.C21Profession] || [],
  listOfCategories: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.Category] || [],
  listOfDepartments: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.CompanyDepartment] || [],
  listOfDurationTasks: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.DurationTask] || [],
  listOfCities: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.City] || [],
  listOfCountries: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.Country] || [],
  listOfLetterTitles: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.LetterTitle] || [],
  listOfMaritalStatuses: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.MaritalStatus] || [],
  listOfPersonDemands: (state: ILookupState) => state.listOfPersonDemands,
  listOfPersonFunctions: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.PersonFunction] || [],
  listOfPersonProperties: (state: ILookupState) => state.listOfPersonProperties,
  listOfPersonProposals: (state: ILookupState) => state.listOfPersonProposals,
  listOfPersonSources: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.PersonSource] || [],
  listOfPersonTypes: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.PersonType] || [],
  listOfPhoneDescriptions: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.PhoneDescription] || [],
  listOfPreConfirmations: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.PreConfirmation] || [],
  listOfPreferredMedia: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.PreferredMedium] || [],
  listOfPurposes: (state: ILookupState) => state.listOfPurposes,
  listOfSourceContact: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.SOURCECONTACT] || [],
  listOfCanceledReason: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.CANCELEDREASON] || [],
  listOfRelationTypes: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.RelationType] || [],
  listOfRelationReverseTypes: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.RelationReverseType] || [],
  listOfSites: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.Site] || [],
  listOfSinceDate: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.SinceDate] || [],
  listOfTaskTypes: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.TaskType] || [],
  listOfTaskGroups: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.TaskGroup] || [],
  listOfPropertyTypes: (state: ILookupState) => state.listTypesOfProperty,
  listTypesOfProperty: (state: ILookupState) => state.listTypesOfProperty,
  listOfGoals: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.ListOfGoal] || [],
  listOfCompanies: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.Company] || [],
  listOfStatuses: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.PropertyStatus] || [],
  listOfPropertyStatusForSearch: (status: ILookupState) => status.storedlookupObject[LOOKUP_TYPE.PropertStatusForSearch] || [],
  listOfStatus: (state: ILookupState) => {
    return state.listOfStatus;
  },
  listOfPropertyStatus: (state: ILookupState) => {
    return state.storedlookupObject[LOOKUP_TYPE.PropertyStatus] || []
  },
  listOfPropertySubStatus: (state: ILookupState) => {
    return state.storedlookupObject[LOOKUP_TYPE.PropertySubStatus] || [];
  },
  listOfDocumentTypes: (state: ILookupState) => {
    return state.listOfDocumentTypes;
  },
  listOfDocumentPublish: (state: ILookupState) => {
    return state.listOfDocumentPublish;
  },
  listCategoriesOfProperty: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.PropertyCategoryType] || [],
  listOfPictureGroups: (state: ILookupState) => {
    return state.listOfPictureGroups;
  },
  listOfRoomDescriptions: (state: ILookupState) => {
    return state.listOfRoomDescriptions;
  },
  listOfRoomCovering: (state: ILookupState) => {
    return state.listOfRoomCovering;
  },
  listOfRoomStates: (state: ILookupState) => {
    return state.listOfRoomStates;
  },
  listOfRoomFloors: (state: ILookupState) => {
    return state.listOfRoomFloors;
  },
  listOfRoomKeywords: (state: ILookupState) => {
    return state.listOfRoomKeywords;
  },
  listOfOrientations: (state: ILookupState) => {
    return state.storedlookupObject[LOOKUP_TYPE.RearOrientation];
  },
  listOfCO2Emission: (state: ILookupState) => {
    return state.listOfCO2Emission;
  },
  listOfInsulation: (state: ILookupState) => {
    return state.listOfInsulation;
  },
  listOfEPCLuxembourg: (state: ILookupState) => {
    return state.listOfEPCLuxembourg;
  },
  listOfEPCBrussels: (state: ILookupState) => {
    return state.listOfEPCBrussels;
  },
  listOfEPCFlanders: (state: ILookupState) => {
    return state.listOfEPCFlanders;
  },
  listOfEPCImmoWeb: (state: ILookupState) => {
    return state.listOfEPCImmoWeb;
  },
  listOfEPCType: (state: ILookupState) => {
    return state.listOfEPCType;
  },
  listOfEPCNR: (state: ILookupState) => {
    return state.listOfEPCNR;
  },
  listOfEPCkNR: (state: ILookupState) => {
    return state.listOfEPCkNR;
  },
  listOfGroundCertificate: (state: ILookupState) => {
    return state.listOfGroundCertificate;
  },
  listOfOilTankPlacement: (state: ILookupState) => {
    return state.listOfOilTankPlacement;
  },
  listOfOilTankFurtherExploitation: (state: ILookupState) => {
    return state.listOfOilTankFurtherExploitation;
  },
  listOfOilTankCertificateOfInspection: (state: ILookupState) => {
    return state.listOfOilTankCertificateOfInspection;
  },
  listOfElectricityImmoWeb: (state: ILookupState) => {
    return state.listOfElectricityImmoWeb;
  },
  listOfGasolineImmoWeb: (state: ILookupState) => {
    return state.listOfGasolineImmoWeb;
  }

  , listOfPermitOptions: (state: ILookupState) => {
    return state.listOfPermitOptions
  }
  , listOfHasSummon: (state: ILookupState) => {
    return state.listOfHasSummon
  }
  , listOfAreaApplication: (state: ILookupState) => {
    return state.listOfAreaApplication
  }
  , listOfHeritageType: (state: ILookupState) => {
    return state.listOfHeritageType
  }
  , listOfFloodRisk: (state: ILookupState) => {
    return state.listOfFloodRisk
  }
  , listOfFloodZoneType: (state: ILookupState) => {
    return state.listOfFloodZoneType
  }
  , listOfYesNo: (state: ILookupState) => {
    return state.listOfYesNo
  }, listOfAsbestosType: (state: ILookupState) => {
    return state.listOfAsbestosType;
  },

  listOfManWoman: (state: ILookupState) => state.listOfManWoman,
  listOfViagerType: (state: ILookupState) => state.listOfViagerType,
  listOfRegisteredTypeBrussels: (state: ILookupState) => state.listOfRegisteredTypeBrussels,
  listOfRegisteredTypeFlanders: (state: ILookupState) => state.listOfRegisteredTypeFlanders,
  listOfRegisteredTypeWallonia: (state: ILookupState) => state.listOfRegisteredTypeWallonia,
  listOfRegisteredTypeNone: (state: ILookupState) => state.listOfRegisteredTypeNone,
  listOfChargeElements: (state: ILookupState) => state.listOfChargeElements,
  listOfPublicUtilities: (state: ILookupState) => state.listOfPublicUtilities,
  getListOfPropertyEnvironment: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.PropertyEnvironment] || [],
  listOfPriceUnits: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.PriceUnit],

  //#region PROPERTY - CONTRUCTION
  [lookupTypesStore.Get.LIST_OF_CONDITION]: (state: ILookupState) => {
    return state.storedlookupObject[LOOKUP_TYPE.ListOfCondition];
  },
  [lookupTypesStore.Get.LIST_OF_CONSTRUCTION]: (state: ILookupState) => {
    return state.storedlookupObject[LOOKUP_TYPE.ListOfConstruction];
  },
  getListOfConstructionType: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.ListOfConstructionType] || [],
  
  [lookupTypesStore.Get.LIST_OF_EXTERIORCOMFORT]: (state: ILookupState) => {
    return state.storedlookupObject[LOOKUP_TYPE.ListOfExteriorcomfort];
  },
  [lookupTypesStore.Get.LIST_OF_GOAL]: (state: ILookupState) => {
    return state.storedlookupObject[LOOKUP_TYPE.ListOfGoal];
  },
  [lookupTypesStore.Get.LIST_OF_HEATING]: (state: ILookupState) => {
    return state.storedlookupObject[LOOKUP_TYPE.ListOfHeating];
  },
  [lookupTypesStore.Get.LIST_OF_HEATINGB]: (state: ILookupState) => {
    return state.storedlookupObject[LOOKUP_TYPE.ListOfHeatingb];
  },
  [lookupTypesStore.Get.LIST_OF_INTERIORCOMFORT]: (state: ILookupState) => {
    return state.storedlookupObject[LOOKUP_TYPE.ListOfInteriorcomfort];
  },
  [lookupTypesStore.Get.LIST_OF_KITCHEN]: (state: ILookupState) => {
    return state.storedlookupObject[LOOKUP_TYPE.ListOfKitchen];
  },
  [lookupTypesStore.Get.LIST_OF_REARORIENTATION]: (state: ILookupState) => {
    return state.storedlookupObject[LOOKUP_TYPE.ListOfRearorientation];
  },
  [lookupTypesStore.Get.LIST_OF_ROOFMATERIAL]: (state: ILookupState) => {
    return state.storedlookupObject[LOOKUP_TYPE.ListOfRoofmaterial];
  },
  [lookupTypesStore.Get.LIST_OF_ROOF]: (state: ILookupState) => {
    return state.storedlookupObject[LOOKUP_TYPE.ListOfRoof];
  },
  [lookupTypesStore.Get.LIST_OF_STYLE]: (state: ILookupState) => {
    return state.storedlookupObject[LOOKUP_TYPE.ListOfStyle];
  },
  [lookupTypesStore.Get.LIST_OF_ROOFCONDITION]: (state: ILookupState) => {
    return state.storedlookupObject[LOOKUP_TYPE.ListOfRoofCondition];
  },
  [lookupTypesStore.Get.LIST_OF_WINDOWSGLAZING]: (state: ILookupState) => {
    return state.storedlookupObject[LOOKUP_TYPE.ListOfWindowsGlazing];
  },
  [lookupTypesStore.Get.LIST_OF_WINDOWFRAME]: (state: ILookupState) => {
    return state.storedlookupObject[LOOKUP_TYPE.ListOfWindowFrame];
  },
  //#endregion

  //#region PERSON
  listOfPersonStatus: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.PersonStatus] || [],
  listOfMandateType: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.ListOfMandateType] || [],
  listOfProlongationType: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.ListOfProlongationType] || [],
  listOfCommissionType: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.ListOfCommissionType] || [],
  listOfDepositType: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.ListOfDepositType] || [],
  listOfPersonType: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.PersonType] || [],
  listOfConfirmEmailTime: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.ListOfConfirmEmailTime] || [],
  listOfParticularConditionClause: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.ListOfParticularConditionClause] || [],
  listOfPrePaymentType: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.ListOfPrePaymentType] || [],
  listOfImmoWebOption: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.ListOfImmoWebOption] || [],
  listOfImmowebDetailedPage: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.ListOfImmowebDetailedPage] || [],
  listPublishUnitTypeOnPortal: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.PUBLISH_UNIT_TYPE_ON_PORTAL] || [],
  listOfPublishOnMedia: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.ListOfPublishOnMedia] || [],
  listOfFinanceReduction: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.ListOfFinanceReduction] || [],
  listOfMonths: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.Month] || [],
  //#endregion

  [lookupTypesStore.Get.LIST_OF_APPOINTMENT_TYPE]: (state: ILookupState) => (state.listOfAppointmentTypes),
  [lookupTypesStore.Get.LIST_OF_APPOINTMENT_STATUS]: (state: ILookupState) => (state.listOfAppointmentStatus),
  [LOOKUP_TYPE.constructionViewType]: (state: ILookupState) => {
    return state.storedlookupObject[LOOKUP_TYPE.constructionViewType] || []
  },
  listOfProjectStatus: (state: ILookupState) => {
    return state.storedlookupObject[LOOKUP_TYPE.projectStatus] || [];
  },
  listOfRentals: (state: ILookupState) => (state.storedlookupObject[LOOKUP_TYPE.rentals] || []),
  listOfReductionType: (state: ILookupState) => (state.storedlookupObject[LOOKUP_TYPE.reductionType] || []),
  listOfFreeAvailable: (state: ILookupState) => (state.storedlookupObject[LOOKUP_TYPE.freeAvailable] || []),
  listOfProjectPhase: (state: ILookupState) => (state.storedlookupObject[LOOKUP_TYPE.projectPhase] || []),
  listOfProjectUsage: (state: ILookupState) => (state.storedlookupObject[LOOKUP_TYPE.projectUsage] || []),
  listOfHistoryType: (state: ILookupState) => (state.storedlookupObject[LOOKUP_TYPE.HistoryType] || []),
  [LOOKUP_TYPE.SMS_MAPPING_KEY]: (state) => (state.storedlookupObject[LOOKUP_TYPE.SMS_MAPPING_KEY] || []),
  [LOOKUP_TYPE.SMS_MAPPING_KEY_LANGS]: (state) => (state.storedlookupObject[LOOKUP_TYPE.SMS_MAPPING_KEY_LANGS] || []),
  [LOOKUP_TYPE.CONFIRM_EMAIL_TIME]: (state) => (state.storedlookupObject[LOOKUP_TYPE.CONFIRM_EMAIL_TIME] || []),
  [LOOKUP_TYPE.CONFIRM_SMS_TIME]: (state) => (state.storedlookupObject[LOOKUP_TYPE.CONFIRM_SMS_TIME] || []),
  [LOOKUP_TYPE.CONFIRMATION_TYPE]: (state) => (state.storedlookupObject[LOOKUP_TYPE.CONFIRMATION_TYPE] || []),
  [LOOKUP_TYPE.OWNER_CONFIRMATION_TYPE]: (state) => (state.storedlookupObject[LOOKUP_TYPE.OWNER_CONFIRMATION_TYPE] || []),
  [LOOKUP_TYPE.CONFIRMATION_MESSAGE]: (state) => (state.storedlookupObject[LOOKUP_TYPE.CONFIRMATION_MESSAGE] || []),
  [LOOKUP_TYPE.SMS_TEMPLATE_TYPE]: (state) => (state.storedlookupObject[LOOKUP_TYPE.SMS_TEMPLATE_TYPE] || []),
  [LOOKUP_TYPE.PRE_CONFIRMATION]: (state) => (state.storedlookupObject[LOOKUP_TYPE.PRE_CONFIRMATION] || []),
  [LOOKUP_TYPE.CONFIRMATION_ALARM]: (state) => (state.storedlookupObject[LOOKUP_TYPE.CONFIRMATION_ALARM] || []),
  [LOOKUP_TYPE.CHECKUP]: (state) => (state.storedlookupObject[LOOKUP_TYPE.CHECKUP] || []),
  [LOOKUP_TYPE.FLOOR_PLAN]: (state) => (state.storedlookupObject[LOOKUP_TYPE.FLOOR_PLAN] || []),
  [LOOKUP_TYPE.CONFIRM_TEMPLATES]: (state) => (state.storedlookupObject[LOOKUP_TYPE.CONFIRM_TEMPLATES] || []),
  [lookupTypesStore.Get.LIST_OF_PERSONAL_BY_AGENDA_ID]: (state: ILookupState) => state.listOfPersonalByAgendaId,
  [lookupTypesStore.Set.LIST_CANDIDATES]: (state: ILookupState) => {
    return state.listOfCandidates || [];
  },
    listOfGender: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.Gender] || [],
    listOfCardType: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.CardType] || [],
    listOfCardSpecialStatus: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.CardSpecialStatus] || [],
    asbestosType: (state: ILookupState) => state.storedlookupObject[LOOKUP_ASBESTOS_TYPE] || [],
    floodZoneType: (state: ILookupState) => state.storedlookupObject[LOOKUP_ADMINISTRATION_FLOODTYPE] || [],

    listOfSocialType: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.LOOKUP_SOCIAL_TYPE] || [],
    listOfSocialPropertyTemplate: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.LOOKUP_SOCIAL_PROPERTY_TEMPLATE] || [],
    listOfSocialProjectTemplate: (state: ILookupState) => state.storedlookupObject[LOOKUP_TYPE.LOOKUP_SOCIAL_PROJECT_TEMPLATE] || [],
    listOfPositiveComments: (state: ILookupState) => state.storedlookupObject[lookupTypesStore.Get.POSITIVE_COMMENTS] || [],
    listOfNegativeComments: (state: ILookupState) => state.storedlookupObject[lookupTypesStore.Get.NEGATIVE_COMMENTS] || [],
    listAgendaStartTime: (state: ILookupState) => { return state.storedlookupObject[LOOKUP_TYPE.AgendaStartTime]; },
    listAuthMode: (state: ILookupState) => { return state.storedlookupObject[LOOKUP_TYPE.AuthMode]; },
    listTaskType: (state: ILookupState) => { return state.storedlookupObject[LOOKUP_TYPE.ShowAppointmentOrTaskType]; },
    listFontWeightType: (state: ILookupState) => { return state.storedlookupObject[LOOKUP_TYPE.FontWeighType]; },
    listDefautAlarm: (state: ILookupState) => { return state.storedlookupObject[LOOKUP_TYPE.DefaultAlarm]; },
    listOfTreviPartners: (state: ILookupState) => { return state.storedlookupObject[LOOKUP_TYPE.TreviPartners]; },
    [LOOKUP_TYPE.TypeSign]: (state) => (state.storedlookupObject[LOOKUP_TYPE.TypeSign] || []),
    [LOOKUP_TYPE.SignStatus]: (state) => (state.storedlookupObject[LOOKUP_TYPE.SignStatus] || []),

    [lookupTypesStore.Get.LIST_PROPERTY_SITE]: (state: ILookupState) => {
        return state.storedlookupObject[LOOKUP_TYPE.PropertySite] || [];
    },
    [lookupTypesStore.Get.LIST_PERSON_SITE]: (state: ILookupState) => {
        return state.storedlookupObject[LOOKUP_TYPE.PersonSite] || [];
    },
    [lookupTypesStore.Get.LIST_DEMAND_SITE]: (state: ILookupState) => {
        return state.storedlookupObject[LOOKUP_TYPE.DemandSite] || [];
    },
    [lookupTypesStore.Get.LIST_COST_TYPE]: (state: ILookupState) => {
        return state.storedlookupObject[LOOKUP_TYPE.CostType];
    },
};

export default getters;